import React, { FC } from 'react';

interface AddIconProps {
  width?: string | number;
  height?: string | number;
  color?: string;
}

const AddIcon: FC<AddIconProps> = ({
  width = '32',
  height = '32',
  color = '#202EA8',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.6154 13.3846H1.38462C0.992308 13.3846 0.663539 13.2518 0.398308 12.9863C0.132769 12.7208 0 12.3918 0 11.9995C0 11.6069 0.132769 11.2782 0.398308 11.0132C0.663539 10.748 0.992308 10.6154 1.38462 10.6154H10.6154V1.38462C10.6154 0.992308 10.7482 0.663539 11.0137 0.398308C11.2792 0.132769 11.6082 0 12.0005 0C12.3931 0 12.7218 0.132769 12.9868 0.398308C13.252 0.663539 13.3846 0.992308 13.3846 1.38462V10.6154H22.6154C23.0077 10.6154 23.3365 10.7482 23.6017 11.0137C23.8672 11.2792 24 11.6082 24 12.0005C24 12.3931 23.8672 12.7218 23.6017 12.9868C23.3365 13.252 23.0077 13.3846 22.6154 13.3846H13.3846V22.6154C13.3846 23.0077 13.2518 23.3365 12.9863 23.6017C12.7208 23.8672 12.3918 24 11.9995 24C11.6069 24 11.2782 23.8672 11.0132 23.6017C10.748 23.3365 10.6154 23.0077 10.6154 22.6154V13.3846Z"
        fill={color}
      />
    </svg>
  );
};

export default AddIcon;
